import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import axiosInstance, { getAPIURL } from '../axiosInstance';
import { dispatchConnectionRemoved } from '../../utils/explorerMessagingError';

interface DeleteProps {
  id: number;
  objectId: string;
}

export const useDeleteConnection = (
  options?: UseMutationOptions<unknown, Error, DeleteProps, unknown>
) => {
  return useMutation<unknown, Error, DeleteProps>({
    ...options,
    mutationFn: async ({ id, objectId }: DeleteProps) => {
      const response = await axiosInstance.delete(
        getAPIURL(`/User/userconnections/${objectId}/${id}`)
      );
      return response.data;
    },
    onSuccess: (data, variables, context) => {
      dispatchConnectionRemoved(variables.id);
      options?.onSuccess?.(data, variables, context);
    },
  });
};
